import { init, reactRouterV6BrowserTracingIntegration, setTags } from '@sentry/react'
import { useEffect } from 'react'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router'

import { appConfig } from '@/app-config/appConfig'
import { getAccessToken, isUnauthorizedError } from '@/lib/auth'
import { CURRENT_VERSION_HASH } from '@/lib/env'
import { isLaunchedAsIOSApp } from '@/lib/ios'
import { isLaunchedAsStandaloneApp } from '@/lib/mobile-app'
import { AppError, isAbortError } from '@/types/error'

export function initializeErrorTracking() {
	init({
		dsn: appConfig.SENTRY_DSN,
		release: CURRENT_VERSION_HASH,
		environment: appConfig.ENV_NAME,
		integrations: [
			reactRouterV6BrowserTracingIntegration({
				useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes,
			}),
		],
		debug: import.meta.env.DEV,
		sampleRate: appConfig.SENTRY_SAMPLE_RATE,
		beforeSend(event, hint) {
			const error = hint?.originalException
			if ((isUnauthorizedError(error) && !getAccessToken()) || isAbortError(error)) {
				return null
			}

			if (AppError.is(error)) {
				return { ...event, fingerprint: [...(Array.isArray(event.fingerprint) ? event.fingerprint : []), error.code] }
			}

			return event
		},
	})
	setTags({
		app_type: isLaunchedAsStandaloneApp() ? 'pwa' : 'browser',
		is_ios_app: String(isLaunchedAsIOSApp()),
	})
}
